import axios from 'axios'
import omit from 'lodash/omit'
import {DeviceAuth, User} from "./domain";
const store = require('store')


const SS_ACCESS_TOKEN = 'fid_access_token';
const SS_USER = 'fid_user';
const S_FID_DEVICE = 'fid_device';
const SS_CATALOG_TOKEN = 'fid_catalog_token';


let accessToken = store.get(SS_ACCESS_TOKEN)

const http = axios.create({
  baseURL: process.env['BACKEND_URL'] || 'https://apis.fidelium.ma',
  timeout: 1000 * 5,
  headers: {'Authorization': accessToken ? 'Bearer ' + accessToken : null}
})

export function totpAuthenticate(token: string, totp: string): Promise<User> {
  const payload = {
    totp: new Buffer(totp).toString('base64'),
  }
  return http.post<User>('/auth/1/totp', payload, {
    headers: {'Authorization': 'Bearer ' + token}
  }).then(({data}) => {
    store.set(SS_ACCESS_TOKEN, data.token)
    store.set(SS_USER, JSON.stringify(omit(data, "token")))
    return data;
  }).catch((error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      throw new Error("Le code PIN semble invalide.")
    } else {
      throw new Error("Une erreur est survenue. Merci de vérifier votre connection. Si l'erreur persiste, veuillez contacter le support Fidelium.")
    }
  })
}

export function getDeviceIdFromSession(): string | null {
  return  store.get(S_FID_DEVICE)
}

export function authenticateDevice(rsa: string): Promise<DeviceAuth> {
  return http.post<DeviceAuth>('/auth/1/rsa', {data: rsa}).then(({data}) => {
    store.set(S_FID_DEVICE, data.deviceId)
    return data;
  }).catch((error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      throw new Error("Informations d'authentification invalides.")
    } else {
      throw new Error("Une erreur est survenue. Merci de vérifier votre connection. Si l'erreur persiste, veuillez contacter le support Fidelium.")
    }
  })
}

export function authenticate(username: string, password: string, token: string | null): Promise<User> {
  const payload = {
    username: new Buffer(username).toString('base64'),
    password: new Buffer(password).toString('base64'),
    token
  }
  return http.post<User>('/auth/1', payload).then(({data}) => {
    if (data && data.token && !data.totpRequired) {
      store.set(SS_ACCESS_TOKEN, data.token)
      store.set(SS_USER, JSON.stringify(omit(data, "token")))
    }
    return data;
  }).catch((error) => {
    console.error("CORS ou problème réseau détecté : ", error);
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      throw new Error("Informations d'authentification invalides.")
    } else {
      throw new Error("Une erreur est survenue. Merci de vérifier votre connection. Si l'erreur persiste, veuillez contacter le support Fidelium.")
    }
  })
}

export function logout(): Promise<void> {
  store.remove(SS_ACCESS_TOKEN)
  store.remove(SS_USER)
  return Promise.resolve();
}

export function getUser(): User | null {
  accessToken = store.get(SS_ACCESS_TOKEN)

  if (accessToken) {
    let user = store.get(SS_USER)
    if (user) {
      try {
        return {...JSON.parse(user), token: accessToken} as User
      } catch (e) {
        console.error(e)
      }
    }
  }
  return null;
}

export function isSessionActive(): boolean {
  accessToken = store.get(SS_ACCESS_TOKEN)
  return !!accessToken
}
